import React from "react"

// --------------------------------------------------------

import {
  awards_page_container,
  awards_page_header,
  awards_page,
  awards_section_cards,
  awards_section
} from "./styles.module.scss"

// --------------------------------------------------------

import Layout from "../../layout"
import Card from "../../components/card"
import Grid from "../../components/grid"

// ---------------------------------------------------------

const AwardsTemplate = (props) => {
  let { data, pageHeading, excerpt } = props

  // ---------------------------------------------------------

  const years = data.map(({ year }) => year)
  const uniqYears = [...new Set(years)].sort((a, b) => b - a)

  // ---------------------------------------------------------

  const multipleOf3 = (n) => {
    if (n % 3 === 0) return true

    return false
  }

  // ---------------------------------------------------------

  const awards = (data, awardYear, index) => {
    const cards = data
      .filter((card) => card.year === awardYear)
      .map((card, index) => (
        <Card
          theme="hover-dark"
          label={card.category}
          title={card.title}
          image={card.image}
          buttonLabel="Read more"
          buttonUrl={card.link}
          year={card.year}
          key={index}
        />
      ))

    return (
      <section className={awards_section} key={index}>
        <h2>{awardYear}</h2>
        <div className={awards_section_cards}>
          {cards}
          {!multipleOf3(cards.length) && <div />}
        </div>
      </section>
    )
  }

  return (
    <Layout className={awards_page} pageTitle={pageHeading} excerpt={excerpt}>
      <Grid column={1} centerText alignment="center" paddingTop="large" paddingBottom="small">
        <header>
          <h1 className={awards_page_header}>{pageHeading}</h1>
        </header>
      </Grid>
      <div className={awards_page_container}>
        {uniqYears.map((year, index) => {
          return awards(data, year, index)
        })}
      </div>
    </Layout>
  )
}

export default AwardsTemplate
